export const EMPLOYEE_COMPETENCES_URL_PATH = '/api/v2/employee-competences';
export const EMPLOYEE_COMPETENCES_MSW_STATUS_KEY = 'employeeCompetencesAPI';
export const EMPLOYEE_AVAILABLE_COMPETENCES_MSW_STATUS_KEY = 'employeeAvailableCompetencesAPI';

export const GET_EMPLOYEE_COMPETENCES_KEY = 'EMPLOYEE_COMPETENCES';
export const GET_EMPLOYEE_AVAILABLE_COMPETENCES_KEY = 'EMPLOYEE_AVAILABLE_COMPETENCES';
